<template>
	<v-btn icon :color="item.pinned ? 'green' : 'grey'" @click="togglePinned"><v-icon>{{item.pinned ? 'mdi-pin' : 'mdi-pin-off'}}</v-icon></v-btn>
</template>
<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "TogglePinned", 
		props: ["item", "id", "subid", "collection", "subkey"],
		data: () => {
			return {

			}
		},
		// components: {

		// },
		// computed: {
			// ...Vuex.mapState({})
		// },
		methods: {
			togglePinned(){
				var obj = {
					collection: this.collection, 
					id: this.id, 
					key: this.subkey, 
					sub_id: this.subid 
				};
				this.$store.dispatch("togglePinned", obj)
			}
		}
		// created(){
			
		// }

	}
</script>